"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var keepMounted_exports = {};
__export(keepMounted_exports, {
  renderKeptMountedScreens: () => renderKeptMountedScreens,
  useVisitedScreens: () => useVisitedScreens
});
module.exports = __toCommonJS(keepMounted_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
function useVisitedScreens(focusedKey) {
  var [visited, setVisited] = (0, import_react.useState)(function() {
    return [
      focusedKey
    ];
  });
  (0, import_react.useEffect)(function() {
    setVisited(function(prev) {
      return prev.includes(focusedKey) ? prev : [
        ...prev,
        focusedKey
      ];
    });
  }, [
    focusedKey
  ]);
  return visited;
}
function renderKeptMountedScreens(screens, visited) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Fragment, {
    children: screens.map(function(screen) {
      if (screen.isFocused) {
        return screen.keepMounted ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Activity, {
          mode: "visible",
          children: screen.element
        }, screen.key) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Fragment, {
          children: screen.element
        }, screen.key);
      }
      if (!screen.keepMounted || !visited.includes(screen.key)) return null;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Activity, {
        mode: "hidden",
        children: screen.element
      }, screen.key);
    })
  });
}
//# sourceMappingURL=keepMounted.js.map
